export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#87CEEB',
    borderColor: state.isFocused ? '#2b6cb0' : '#ccc',
    boxShadow: state.isFocused ? '0 0 0 1px #2b6cb0' : 'none',
    '&:hover': {
      borderColor: '#2b6cb0',
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#FFFFFF',
    borderColor: '#F8F9FD',
    backgroundColor: 'transparent',
  }),
  multiValue: (provided) => ({
    ...provided,
    color: '#FFFFFF',
    // border: '1px solid #F8F9FD',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#FFFFFF',
    // border: '1px solid #F8F9FD',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  }),
  input: (provided) => ({
    ...provided,
    color: '#FFFFFF',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#FFFFFF',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#FFFFFF',
    '&:hover': {
      color: '#FFFFFF',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
};